import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicCarrier } from 'src/app/shared/models/public-carrier';
import { CarrierDataService } from 'src/app/shared/services/carrier-data.service';
import { ROUTE_DRIVER_JOB, ROUTE_DRIVER_JOB_SIGN_IN, ROUTE_DRIVER_JOB_SIGN_UP } from '../shared/routes';

@Component({
    selector: 'app-job-rejected',
    templateUrl: './job-rejected.component.html',
    styleUrls: ['./job-rejected.component.scss'],
    standalone: false
})
export class JobRejectedComponent implements OnInit {
  carrierCompanyId: string = null;
  publishableKey: string = null;
  carrierData: PublicCarrier = null;

  constructor(
    private readonly router: Router,
    private readonly carrierDataService: CarrierDataService
  ) { }

  ngOnInit(): void {
    this.carrierCompanyId = sessionStorage.getItem('carrierCompanyId');
    this.publishableKey = sessionStorage.getItem('publishableKey');

    if (this.carrierCompanyId && this.publishableKey) {
      this.loadCarrierData(this.carrierCompanyId);
    }
  }

  ngOnDestroy(): void {
    this.clearSessionKeys();
  }

  loadCarrierData(companyId: string): void {
    this.carrierDataService.getCarrierPublicById(companyId).subscribe({
      next: (response) => {
        this.carrierData = response;
      },
      error: (err) => {
        console.error('Error fetching carrier data', err);
      }
    });
  }

  onNavigateToSignIn() {
    this.clearSessionKeys();
    this.router.navigate([`/${ROUTE_DRIVER_JOB}`, ROUTE_DRIVER_JOB_SIGN_IN]);
  }

  onNavigateToSignUp() {
    this.clearSessionKeys();
    this.router.navigate([`/${ROUTE_DRIVER_JOB}`, ROUTE_DRIVER_JOB_SIGN_UP]);
  }

  private clearSessionKeys(): void {
    sessionStorage.removeItem('carrierCompanyId');
    sessionStorage.removeItem('publishableKey');
  }
}
